<script>
  const date = new Date();
</script>

<style>
  .footer {
    background: #eeecec;
    text-align: center;
    padding: 1rem;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    box-shadow: 0 3rem 4rem rgba(0, 0, 0, 0.4);
    border-radius: 3px;
  }

  .copy {
    font-size: 1.6rem;
    color: #444;
  }

  @media only screen and (max-width: 950px) {
    .footer {
      box-shadow: none;
      border-top: 1px solid rgba(0, 0, 0, 0.3);
      border-radius: 0;
      z-index: 20;
    }
  }

  @media only screen and (max-width: 400px) {
    .footer {
      border-top: 1px solid rgba(0, 0, 0, 0.3);
    }
  }
</style>

<div class="footer">
  <p class="copy">Nbred © {date.getFullYear()} - All rights reserved</p>
</div>
